import { Injectable } from '@angular/core';

@Injectable()
export class DynamicUtilsService {
  parseUrlToBeProcessable(url: string): string {
    let parsed: string = url.split('/').join(',');
    return parsed === ',' ? '' : parsed;
  }
}
